// import { Box } from '@mui/material';
// import styles from '../../styles/helpers.module.css';

// const GridOverlayLayer = () => {
//   return (
//     <Box
//       className={styles.gridOverlay}
//       sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         pointerEvents: 'none',
//         zIndex: 0,
//       }}
//     />
//   );
// };

// export default GridOverlayLayer;

import React, { memo } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

function GridOverlayLayer({ opacity = 0.06, size = 48 }) {
  const theme = useTheme();
  const gridOverlay =
    theme?.custom?.layers?.gridOverlay ??
    'linear-gradient(rgba(255,255,255,.12) 1px, transparent 1px), ' +
    'linear-gradient(90deg, rgba(255,255,255,.12) 1px, transparent 1px)';

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        opacity,
        backgroundImage: gridOverlay,
        backgroundSize: `${size}px ${size}px`,
        animation: 'gridShift 22s linear infinite',
        '@keyframes gridShift': {
          to: { backgroundPosition: '200px 200px, 200px 200px' }
        }
      }}
    />
  );
}

export default memo(GridOverlayLayer);
